import api from './api';

export const ubicacionesService = {
    // Obtener todas las ubicaciones
    getUbicaciones: async (params = {}) => {
        const { skip = 0, limit = 100, activa } = params;
        const queryParams = new URLSearchParams({ skip: skip.toString(), limit: limit.toString() });
        
        if (activa !== undefined) {
            queryParams.append('activa', activa.toString());
        }
        
        const response = await api.get(`/ubicaciones?${queryParams}`);
        return response.data;
    },

    // Obtener ubicaciones para selector desplegable
    getUbicacionesSelect: async (activa = true) => {
        const response = await api.get(`/ubicaciones/select?activa=${activa}`);
        return response.data;
    },

    // Crear ubicación
    createUbicacion: async (ubicacionData) => {
        const response = await api.post('/ubicaciones', ubicacionData);
        return response.data;
    },

    // Obtener ubicación por ID
    getUbicacionById: async (id) => {
        const response = await api.get(`/ubicaciones/${id}`);
        return response.data;
    },

    // Obtener ubicación por código
    getUbicacionByCodigo: async (codigo) => {
        const response = await api.get(`/ubicaciones/codigo/${codigo}`);
        return response.data;
    },

    // Obtener ubicaciones por tipo
    getUbicacionesByTipo: async (tipo) => {
        const response = await api.get(`/ubicaciones/tipo/${tipo}`);
        return response.data;
    },

    // Obtener jerarquía de ubicaciones
    getJerarquia: async (ubicacionPadreId = null) => {
        const params = ubicacionPadreId ? `?ubicacion_padre_id=${ubicacionPadreId}` : '';
        const response = await api.get(`/ubicaciones/jerarquia${params}`);
        return response.data;
    },

    // Actualizar ubicación
    updateUbicacion: async (id, ubicacionData) => {
        const response = await api.put(`/ubicaciones/${id}`, ubicacionData);
        return response.data;
    },

    // Eliminar ubicación
    deleteUbicacion: async (id) => {
        const response = await api.delete(`/ubicaciones/${id}`);
        return response.data;
    }
};